import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { toPascalCase } from '../../utils/string'
import style from './status.module.scss'
import './effects.scss'
import PropTypes from 'prop-types'
import { VegaIcon } from '../vega/icon/Icon'
import VegaColors from '../../resources/constants/colors.module.scss'

const Status = (props) => {
	const { className, statusGroupName, hasCorrespondBank } = props
	const [oldPropsState, setPropsState] = useState(props)

	useEffect(() => {
		if (oldPropsState !== props) {
			setPropsState(props)
		}
	}, [oldPropsState, props])

	useEffect(() => {
		import(`./animations/${statusGroupName.toLowerCase()}`).then((animation) => {
			animation.start(hasCorrespondBank)
		})
	})

	return (
		oldPropsState === props && (
			<div className={cx(className, style.status)}>
				<div id={'line1'} className={cx(style.line, style.line1)} />
				<div id={'line2'} className={cx(style.line, style.line2)} />
				<Break />
				<div id={'dot1'} className={cx(style.dot, style.dot1)} />
				<div id={'dot2'} className={cx(style.dot, style.dot2)} />
				<div id={'dot3'} className={cx(style.dot, style.dot3)} />
				<Icon name={'data-health'} />
				<Icon name={'check'} />
				<Icon name={'link'} />
				<Icon name={'indicator-warning'} />
				<Icon name={'close'} color={VegaColors.CONTENTWHITE} size={10} />
			</div>
		)
	)
}

const Break = () => {
	const id = 'break'
	const className = cx(style.break)

	let crumbs = []

	for (let i = 0; i < 12; i++) {
		crumbs.push(<div key={i} className={style.crumb} />)
	}

	return (
		<div id={id} className={className}>
			<div className={style.tip} />
			<div className={style.cut}>{crumbs}</div>
			<div className={style.tip} />
		</div>
	)
}

const Icon = ({ name, color, size = 14 }) => {
	const id = `icon${toPascalCase(name)}`
	const className = cx(style.icon)

	return (
		<div id={id} className={className}>
			<VegaIcon name={name} size={size} color={color} />
		</div>
	)
}

Status.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string
}

export { Status }
